export default "__VITE_ASSET__rK8iq1yS__"